import { render, staticRenderFns } from "./UpdateDefaultRoadmap.vue?vue&type=template&id=22ac1150"
import script from "./UpdateDefaultRoadmap.vue?vue&type=script&lang=js"
export * from "./UpdateDefaultRoadmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports